import React, { Component } from 'react';
import { Nav, NavDropdown, MenuItem } from 'react-bootstrap';
import { connect } from 'react-redux';

class HeaderLinks extends Component {
	_isMounted = false; //initialize the component as false
	constructor(props) {
		super(props);
		this.state = {
			notifications: ''
		};
	}
	logout(event) {
		localStorage.removeItem('token');
		this.props.history.push('');
	}

	componentWillMount() {
		this._isMounted = true;
	}

	componentWillUnmount() {
		this._isMounted = false; //changes to false when the component is no longer mounted
	}

	render() {
		const AdminLinks = (
			<Nav pullRight>
				<NavDropdown eventKey={2} title="Settings" noCaret id="basic-nav-dropdown">
					<MenuItem eventKey={2.1} href="#" onClick={this.logout.bind(this)}>
						Log Out{' '}
						<i className={'pe-7s-power'} style={{ fontSize: '25px', float: 'right', color: 'red' }} />
					</MenuItem>
				</NavDropdown>
			</Nav>
		);
		/* const CloseSession = (
			<button className="button-close-session" onClick={this.logout.bind(this)}>
				<i className={'pe-7s-power'} style={{ fontSize: '25px', float: 'right', color: 'red' }} />
			</button>
		); */
		return <div>{AdminLinks}</div>;
	}
}

HeaderLinks.propTypes = {};

HeaderLinks.contextTypes = {};

function mapStateToProps(state) {
	return {
		auth: state.auth,
		numberNotificationList: state.numberNotificationList
	};
}

export default connect(mapStateToProps, {})(HeaderLinks);
